import {
  type BaseState,
  HOST_QUERY_KEY,
  metaApiInstance,
  type ServiceAppState,
} from '@kc-console/context';
import { STATUS_CODE } from '@kc-console/core';

import { StatusServiceKeyword } from '../../../constants';
import { getServerTraceHttpTimingOptions } from '../../../utils/serverTrace/store';

import type { Guard } from '../../../types';

/**
 * Status Dashboard 에서 리전 및 엔드포인트 정보를 조회하는 가드
 */
export const determineRegionEndpointGuard: Guard<ServiceAppState & BaseState> = async ({
  context,
  queryClient,
}) => {
  const { fetchKeywordMetadata } = metaApiInstance({
    ...getServerTraceHttpTimingOptions(context.req, 'config'),
  });

  try {
    await queryClient.fetchQuery({
      queryKey: [HOST_QUERY_KEY.GET_KEYWORD_ENDPOINT, { serviceKeyword: StatusServiceKeyword }],
      queryFn: () => fetchKeywordMetadata({ serviceKeyword: StatusServiceKeyword }),
    });
  } catch {
    return { status: STATUS_CODE.INTERNAL_SERVER_ERROR };
  }
  return { status: STATUS_CODE.OK };
};

determineRegionEndpointGuard.displayName = 'determineRegionEndpointGuard';
